export default 'https://tme.understood.org/assets/background.4966fdbe.glb'